import { ConsoleTeam } from 'shared/models/team'

import { getRequest } from '../api/common'

const URL_BASE = '/api/v1/console/'

export type Team = ConsoleTeam

export function getTeam(id: string | undefined) {
  return getRequest(`${URL_BASE}teams/${id}/`).then((response: Team) => {
    return response
  })
}

export function searchTeams(search?: string) {
  const encodedSearch = encodeURIComponent(search || '')
  return getRequest(`${URL_BASE}teams/?ordering=-id&page=1&page_size=25&search=${encodedSearch}`).then(
    (response: { count: number; next: string | null; previous: string | null; results: Team[] }) => {
      return response
    }
  )
}
